import { useState, useCallback } from 'react';
import { api } from '../lib/api';
import type { Employee } from '../lib/types';

export function useEmployees() {
  const [employees, setEmployees] = useState<Employee[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchEmployees = useCallback(async (params?: Record<string, string>) => {
    setLoading(true);
    setError(null);
    try {
      const { employees: data } = await api.employees.list(params);
      setEmployees(data as unknown as Employee[]);
    } catch (err) {
      setError(err instanceof Error ? err.message : '社員一覧の取得に失敗しました');
    } finally {
      setLoading(false);
    }
  }, []);

  const createEmployee = async (data: Record<string, unknown>) => {
    try {
      await api.employees.create(data);
      await fetchEmployees();
      return true;
    } catch (err) {
      setError(err instanceof Error ? err.message : '社員の登録に失敗しました');
      return false;
    }
  };

  const updateEmployee = async (id: string, data: Record<string, unknown>) => {
    try {
      await api.employees.update(id, data);
      await fetchEmployees();
      return true;
    } catch (err) {
      setError(err instanceof Error ? err.message : '社員の更新に失敗しました');
      return false;
    }
  };

  const deleteEmployee = async (id: string) => {
    try {
      await api.employees.delete(id);
      await fetchEmployees();
      return true;
    } catch (err) {
      setError(err instanceof Error ? err.message : '社員の削除に失敗しました');
      return false;
    }
  };

  return {
    employees,
    loading,
    error,
    fetchEmployees,
    createEmployee,
    updateEmployee,
    deleteEmployee,
  };
}
